<template>
    <div class="part_one">
        <div class="left">
            <div class="video_box ">
                <video id="video-box-play" webkit-playsinline playsinline x5-video-player-type="h5-page" x5-playsinline x-webkit-airplay='allow' :poster="currNavItem.poster" class="playerVideo" @ended="videoEnd" @playing="playingVideo" @pause="pauseVideo" width="100%" height="100%" :src="currNavItem.video" :muted="!isAudioPlay" preload="auto" autoplay="autoplay" v-if="!isMobile">
                </video>

                <div class="video_box_canvas" id="video_box_0" style="display:block;"></div>
                <div class="video_box_canvas" id="video_box_1" style="display:none;"></div>
                <div class="video_box_canvas" id="video_box_2" style="display:none;"></div>
                <div class="video_box_canvas" id="video_box_3" style="display:none;"></div>
                <div class="txt"></div>
                <!-- <div class="play" v-if="navVideoPlay"></div> -->
                <div class="webnavClik pcShow" @click.stop.prevent="playVideoClick"></div>
                <div class="webnavClik webShow" @click.stop.prevent="playVideoWebClick"></div>
                <div class="play_btn" :class="isAudioPlay ? '' : 'close'" @click.stop.prevent="audioPlay"></div>
                <!-- <div class="mask-div" @click="toUrl"></div> -->
            </div>

            <div class="desc pcShow">
                <div class="desc_box" @click.stop="toUrl">
                    <div class="name">{{ currNavItem.txt }}</div>
                    <div class="txt">{{ currNavItem.desc }}</div>
                </div>
            </div>
            <div class="desc webShow">
                <div class="desc_box" @click.stop="toUrl">
                    <div class="name">{{ currNavItem.txt }}</div>
                    <div class="txt">{{ currNavItem.desc }}</div>
                </div>
            </div>
        </div>
        <div class="right">
            <div class="item " v-for="(item, index) in navList" :class="index == currNavIndex ? 'nav_active' : ''" @click.stop="navVideoClick(item, index)" @mouseenter="moveEnter(item, index)" @mouseleave="moveLeave(item, index)">
                <img :src="item.image_gif_poster" alt="" class="pcShow">
                <img :src="item.web_image_list" alt="" class="webShow">
                <div class="txt">{{ item.txt }}</div>
                <div class="mask"></div>
                <div class="border-mask"></div>
            </div>
        </div>
    </div>
</template>

<script>
import { isMobile } from '../../../utils/index';
export default {
    components: {

    },
    props: {
        navList: {
            type: Array,
            default: []
        },
    },
    data() {
        return {
            isMobile: isMobile(),
            currNavItem: null,
            currNavIndex: 0,
            isAudioPlay: false,
            partCanvasList:[],
        };
    },
    created() {
        for (var k in this.navList) {
            this.navList[k]['active'] = k == 0;
        }
        this.currNavItem = this.navList[0];
    },
    mounted() {
        if (this.isMobile) {
            this.initPartList();
            this.partCanvasList[0].play();
        }
    },
    beforeDestroy() {
        for (var k in this.partCanvasList) {
            this.partCanvasList[k].stop();
        }
    },
    methods: {
        initPartList() {
            // swiper 1
            var url_1 = [];
            for (var i = this.navList[0].wap.animationMin; i <= this.navList[0].wap.animationMax; i++) {
                url_1.push(this.navList[0].wap.animationUrl + i + this.navList[0].wap.animationExt);
            }
            var part1CanvasImageObject = new CanvasAnimation({
                id: 'video_box_0',
                canvasWidth: 1336,
                canvasHeight: 980,
                speed: 34,
                imagePlayType: CanvasAnimationImagePlayType.LoadingAndPlay,
                showLoading: false,
                autoPlay: false,
                audioSrc: this.navList[0].wap.animationAudio,
                audioTime: 21,
                audioMuted: true,
                showLoading: true,
                loop: false,
            });
            part1CanvasImageObject.setDefaultImage(url_1[0]);
            part1CanvasImageObject.setImagesUrls(url_1);
            part1CanvasImageObject.init();
            part1CanvasImageObject.onFinishEvent = this.videoEnd;
            this.part1CanvasImageObject = part1CanvasImageObject;
            // swiper 2
            var url_2 = [];
            for (var i = this.navList[1].wap.animationMin; i <= this.navList[1].wap.animationMax; i++) {
                url_2.push(this.navList[1].wap.animationUrl + i + this.navList[1].wap.animationExt);
            }
            var part2CanvasImageObject = new CanvasAnimation({
                id: 'video_box_1',
                canvasWidth: 1336,
                canvasHeight: 980,
                speed: 40,
                imagePlayType: CanvasAnimationImagePlayType.LoadingAndPlay,
                showLoading: false,
                autoPlay: false,
                audioSrc: this.navList[1].wap.animationAudio,
                audioTime: 23,
                audioMuted: true,
                showLoading: true,
                loop: false,
            });
            part2CanvasImageObject.setDefaultImage(url_2[0]);
            part2CanvasImageObject.setImagesUrls(url_2);
            part2CanvasImageObject.init();
            part2CanvasImageObject.onFinishEvent = this.videoEnd;
            this.part2CanvasImageObject = part2CanvasImageObject;
            // swiper 3
            var url_3 = [];
            for (var i = this.navList[2].wap.animationMin; i <= this.navList[2].wap.animationMax; i++) {
                url_3.push(this.navList[2].wap.animationUrl + i + this.navList[2].wap.animationExt);
            }
            var part3CanvasImageObject = new CanvasAnimation({
                id: 'video_box_2',
                canvasWidth: 1336,
                canvasHeight: 980,
                speed: 34,
                imagePlayType: CanvasAnimationImagePlayType.LoadingAndPlay,
                showLoading: false,
                autoPlay: false,
                audioSrc: this.navList[2].wap.animationAudio,
                audioTime: 10,
                audioMuted: true,
                showLoading: true,
                loop: false,
            });
            part3CanvasImageObject.setDefaultImage(url_3[0]);
            part3CanvasImageObject.setImagesUrls(url_3);
            part3CanvasImageObject.init();
            part3CanvasImageObject.onFinishEvent = this.videoEnd;
            this.part3CanvasImageObject = part3CanvasImageObject;
            // swiper 4
            var url_4 = [];
            for (var i = this.navList[3].wap.animationMin; i <= this.navList[3].wap.animationMax; i++) {
                url_4.push(this.navList[3].wap.animationUrl + i + this.navList[3].wap.animationExt);
            }
            var part4CanvasImageObject = new CanvasAnimation({
                id: 'video_box_3',
                canvasWidth: 1336,
                canvasHeight: 980,
                speed: 40,
                imagePlayType: CanvasAnimationImagePlayType.LoadingAndPlay,
                showLoading: false,
                autoPlay: false,
                audioSrc: this.navList[3].wap.animationAudio,
                audioTime: 24,
                audioMuted: true,
                showLoading: true,
                loop: false,
            });
            part4CanvasImageObject.setDefaultImage(url_4[0]);
            part4CanvasImageObject.setImagesUrls(url_4);
            part4CanvasImageObject.init();
            part4CanvasImageObject.onFinishEvent = this.videoEnd;
            this.part4CanvasImageObject = part4CanvasImageObject;
            this.partCanvasList = [
                this.part1CanvasImageObject,
                this.part2CanvasImageObject,
                this.part3CanvasImageObject,
                this.part4CanvasImageObject
            ];
        },


        navVideoClick(item, index) {
            this.currNavItem = item;
            for (var k in this.navList) {
                this.navList[k].active = k == index;
            }
            this.currNavIndex = index;
            if (this.isMobile) {
                for (var k in this.partCanvasList) {
                    this.partCanvasList[k].reset();
                }
                for (var k in this.partCanvasList) {
                    if (k == this.currNavIndex) {
                        window.$("#video_box_" + k).show();
                        this.partCanvasList[k].play();
                        this.partCanvasList[k].setAudioMuted(!this.isAudioPlay);
                    } else {
                        this.partCanvasList[k].stop();
                        this.partCanvasList[k].setAudioMuted(true);
                        window.$("#video_box_" + k).hide();
                    }
                }
            }

        },
        moveEnter(item, index) {

        },
        moveLeave(item, index) {

        },
        toUrl() {
            window.location.href = this.currNavItem.url;
        },
        videoEnd() {
            console.log('videoEnd');
            if (this.isMobile) {
                for (var k in this.partCanvasList) {
                    this.partCanvasList[k].reset();
                }
            }
            this.currNavIndex++;
            if (this.currNavIndex >= 4) {
                this.currNavIndex = 0;
            }
            if (this.isMobile) {
                for (var k in this.partCanvasList) {
                    if (k == this.currNavIndex) {
                        window.$("#video_box_" + k).show();
                        this.partCanvasList[k].play();
                        this.partCanvasList[k].setAudioMuted(!this.isAudioPlay);
                    } else {
                        this.partCanvasList[k].stop();
                        this.partCanvasList[k].setAudioMuted(true);
                        window.$("#video_box_" + k).hide();
                    }
                }
            } else {
                this.currNavItem = this.navList[this.currNavIndex];
            }
        },
        playingVideo() {

        },
        pauseVideo() {

        },
        playVideoClick() {


        },
        playVideoWebClick() {


        },
        audioPlay() {
            this.isAudioPlay = !this.isAudioPlay
            console.log(this.isAudioPlay, 'isAudioPlay');
            if (this.isMobile) {
                for (var k in this.partCanvasList) {
                    this.partCanvasList[k].setAudioMuted(!this.isAudioPlay);
                }
            } else {
                console.log(window.$("#video-box-play")[0])
                window.$("#video-box-play")[0].muted = !this.isAudioPlay;
            }
        },


    },
};
</script>
<style scoped lang="scss" >
.main-page .part_one {
    width: 100%;
    height: 9.9rem;
    display: flex;
}

.main-page .part_one .left {
    width: 13.37rem;
    height: 100%;
    position: relative;
}

.main-page .part_one .left .mask-div {
    position: absolute;
    left: 0;
    top: 0;
    z-index: 200;
    width: 100%;
    height: 100%;
}

.main-page .part_one .video_box {
    width: 100%;
    height: 100%;
    position: relative;
    overflow: hidden;
    /* background: #e60012; */

    .video_box_canvas {
        width: 100%;
        height: 73.33vw;
        position: relative;
        top: 50%;
        transform: translateY(-50%);
    }
}

.main-page .part_one .playerVideo {
    width: 100%;
    height: 100%;
    object-fit: cover;
    position: absolute;
    top: 0;
    left: 0;
}


.play_btn {
    position: absolute;
    right: .4rem;
    bottom: .4rem;
    width: .32rem;
    height: .26rem;
    background: url(../../../assets/index/audio_play.png) no-repeat;
    background-size: 100% auto;
    z-index: 201;
    cursor: pointer;
}

.play_btn.close {
    width: .32rem;
    height: .26rem;
    background: url(../../../assets/index/audio_pause.png) no-repeat;
    background-size: 100% auto;
}

.main-page .part_one .left .dplayer {
    width: 100%;
    height: 100%;
    position: absolute;
}

.main-page .part_one .left .desc {
    width: 100%;
    color: #fff;
    position: absolute;
    bottom: 0;
    left: 0;
    padding: 0.14rem 0 0.2rem 0;
    background: rgba(0, 0, 0, .7);
    z-index: 100;
    cursor: pointer;
}

.main-page .part_one .left .desc_box {
    width: 86%;
    color: #fff;
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;
    height: 100%;
    padding-left: .5rem;
}

.main-page .part_one .left .desc .name {
    font-size: 0.24rem;
    position: relative;
    line-height: .50rem;
}

.main-page .part_one .left .desc .name::after {
    content: '';
    position: absolute;
    left: 0rem;
    bottom: 0rem;
    background: #e50011;
    width: 0.8rem;
    height: 0.04rem;
}

.main-page .part_one .left .desc .txt {
    font-size: 0.216rem;
    padding-top: 0.16rem;
    line-height: .32rem;
}

.videoPlay {
    z-index: 1000;
}

.main-page .part_one>>>.dplayer-bezel .dplayer-bezel-icon {
    z-index: 99;
    pointer-events: auto;
}

.main-page .part_one .left .play {
    position: absolute;
    transform: translate(-50%, -50%);
    left: 50%;
    top: 50%;
    width: 1.14rem;
    height: 1.14rem;
    background: url(../../../assets/index/play_btn.png) no-repeat;
    background-size: 100% auto;
}

.main-page .part_one .right {
    width: 5.83rem;
    height: 100%;
    display: flex;
    flex-direction: column;
}

.main-page .part_one .item {
    width: 100%;
    height: 2.475rem;
    box-sizing: border-box;
    position: relative;

    img {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }
}

.main-page .part_one .item .mask {
    position: absolute;
    left: 0;
    top: 0;
    background: rgba(0, 0, 0, .4);
    width: 100%;
    height: 100%;
    z-index: 9;
    color: #ffffff;
}

.main-page .part_one .item .border-mask {
    width: 100%;
    height: 100%;
    border: 0.05rem solid transparent;
    box-sizing: border-box;
    box-sizing: border-box;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 99;
    border-bottom: none;
}

.main-page .part_one .item:last-child .border-mask {
    border-bottom: 0.05rem solid transparent;
}

.main-page .part_one .item .txt {
    position: absolute;
    bottom: 0;
    left: 0;
    font-size: 0.22rem;
    color: #ffffff;
    height: 0.5rem;
    line-height: .5rem;
    background: rgba(0, 0, 0, .7);
    width: 100%;
    padding-left: 0.3rem;
    z-index: 20;
    box-sizing: border-box;
}

.main-page .part_one .item.nav_active .border-mask {
    border-color: #ffffff;
    border-bottom: 0.05rem solid #fff;
}

.main-page .part_one .item.nav_active .txt {
    z-index: 12;
}

.main-page .part_one .item.nav_active .mask {
    display: none;
}

@media screen and (max-width: 768px) {
    .main-page .kv {
        width: 100%;
        height: 3.83rem
    }

    .main-page .part_one {
        height: auto;
        flex-direction: column;
    }

    .main-page .part_one .left {
        width: 100%;
        display: flex;
        flex-direction: column;
        /* border-bottom: 0.08rem solid #e60012 */
    }

    .main-page .part_one .left .video_box {
        width: 100%;
        height: 4.12rem;

        position: relative;
    }

    .main-page .part_one .left .desc {
        width: 100%;
        position: relative;
        height: 1.85rem;
        bottom: 0;
        background: #e60012;
        margin: 0rem;
        padding: 0rem;


    }

    .main-page .part_one .right {
        width: 2.1rem;
        width: 100%;
        flex-direction: row;

    }

    .main-page .part_one .left .desc .name {
        font-size: 0.28rem;
        line-height: normal;

    }

    .main-page .part_one .left .desc .txt {
        font-size: 0.2rem
    }

    .main-page .part_one .left .desc .name::after {
        position: absolute;
        left: 0rem;
        bottom: -0.1rem;
        background: #fff;
        width: 0.8rem;
        height: 0.04rem;
    }

    .main-page .part_one .item .txt {
        font-size: 0.24rem;
    }

    .main-page .part_one .item {
        /* width: 2.1rem; */
        width: 25%;
        height: 1.75rem
    }

    .main-page .part_one .playerVideo {
        width: 100%;
        height: 4.21rem;
        object-fit: cover;
        object-position: center center;
    }

    .video_div {
        /* display: none !important; */
        opacity: 0;
    }
}
</style>
